import React from 'react'

const InputCheckbox = ({
  checkbox,
  checked = false,
  id,
  name,
  title,
  ...props
}) => (
  <div className="field">
    <input
      className="is-checkradio"
      id={id}
      type="checkbox"
      name={name}
      checked={checked}
      {...props}
    />
    <label htmlFor={id}> {name} </label>
  </div>
)

export default InputCheckbox



// WEBPACK FOOTER //
// ./src/components/views/widgets/InputCheckbox.js